import Rails from "@rails/ujs";
const ajax = Rails.ajax;
const fire = Rails.fire;
import toastr from "toastr";

$(document).ready(function() {
  if ($("#fundsFilterForm").length === 0) {
    return ;
  }

  var timerThrottle;
  var timerDebounce;

  var submitForm = function () {
    fire($("#fundsFilterForm")[0], "submit");
  }

  var debounceFunction = function (func, delay) {
    // Cancels the setTimeout method execution
    clearTimeout(timerDebounce);

    // Executes the func after delay time.
    timerDebounce = setTimeout(function () {
      throttleFunction(func, 500)
    }, delay);
  }

  var throttleFunction = function (func, delay) {
    // If setTimeout is already scheduled, no need to do anything
    if (timerThrottle) {
      return
    }

    // Schedule a setTimeout after delay seconds
    timerThrottle = setTimeout(function () {
      func()

      // Once setTimeout function execution is finished, timer = undefined so that in <br>
      // the next scroll event function execution can be scheduled by the setTimeout
      timerThrottle = undefined;
    }, delay)
  }

  var fetchFundInformation = function() {
    var selected = $('.selected.fund', "#fundsList");

    if (selected.length !== 1) {
      return ;
    }

    var selected_value = parseInt(selected[0].dataset['value']);

    if (isNaN(selected_value)) {
      return ;
    }

    ajax({
      type: 'GET',
      url: $("#fundsList").data('url'),
      data: 'fund_id=' + selected_value,
      dataType: 'json',
      success: function(response) {
        $('#fundName').text(response['fund_name']);
        $('#investorsCountValue').text(response['profiles_count']);
        $('#investedAmountValue').text(response['invested_amount'] + ' ' + response['currency']);
        $('#seeFund').attr('href', response['fund_path']);
      },
      error: function(response) {
        toastr["error"](response);
      }
    })
  }

  $('#fundSearchBar').on('keyup', function() {
    if ($(this).val().length >= 2 || $(this).val().length == 0) {
      debounceFunction(submitForm, 500);
    }
  });

  $('#fundsList').on('click', '.fund', function() {
    $('.fund').removeClass('selected');
    $(this).addClass('selected');
    fetchFundInformation();
  });

  fetchFundInformation();
});
